import { render, staticRenderFns } from "./HandleItemCategory.vue?vue&type=template&id=4144443c"
import script from "./HandleItemCategory.vue?vue&type=script&lang=js"
export * from "./HandleItemCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports